import { ReactNode } from 'react';

export interface ModalBodyProps {
  children: ReactNode;
  className?: string;
}

/**
 * Standardized modal body with consistent padding (responsive)
 */
export function ModalBody({ children, className = '' }: ModalBodyProps) {
  return (
    <div data-tsx-id="modal-body" className={`p-4 sm:p-6 ${className}`}>
      {children}
    </div>
  );
}
